module.exports = __webpack_public_path__ + "img/icon-1.6a110a93.png";